import { render } from "./BaseButtonGroup.vue?vue&type=template&id=6d6735db&scoped=true"
import script from "./BaseButtonGroup.vue?vue&type=script&lang=ts"
export * from "./BaseButtonGroup.vue?vue&type=script&lang=ts"

import "./BaseButtonGroup.vue?vue&type=style&index=0&id=6d6735db&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6d6735db"

export default script